


<template>
  <div>
    <h2>Confirmer l'envoi</h2>

    <div v-if="documentReady" class="centered-child" style="margin-top: 48px; color: white; background-color: red">
      <div class="md-headline">Dossier déjà validé</div>
    </div>


    <div class="centered-child" style="margin-top: 48px; align-items: center; flex-direction: column">
        <md-button class="md-accent" @click="onClickView()">Visualiser le PDF</md-button>

        <md-button v-if="!confirmed && !documentReady" class="md-raised md-primary large-button"
         @click="onClickConfirm()" :disabled="!pdfOpened || loading">Confirmer l'envoi au Client</md-button>
    </div>
  </div>

</template>


<script>
import ServiceAccess from '../service/ServiceAccess'

export default {

  data: function () {
    return {
      values: null,
      stage: null,
      pdfOpened: false,
      loading: false,
      confirmed: false
    }
  },

  computed: {
    documentReady: function () {
      return this.stage && this.stage.name === 'document-ready'
    }
  },

  created: function () {
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadStage(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [values, stage] = responses
      this.values = values
      this.stage = stage
    })
  },


   // -----------------------------------------------------------------------

  methods: {
    onClickView: function () {
      let pdfURL = ServiceAccess.instance.serviceURL + '/file/' + this.$route.params.sessionId + '/' + this.$route.params.filename
      window.open(pdfURL, '_blank')
      this.pdfOpened = true 
    },
    onClickConfirm: function () {
      this.loading = true
      ServiceAccess.instance.confirmFileReview(this.$route.params.sessionId, this.$route.params.sign, this.$route.params.filename).then((response) => {
        this.loading = false
        this.confirmed = true
      }, err => {
        console.err('Error: ', err) 
        this.loading = false 
      })

    }
  }
}

</script>


// WEBPACK FOOTER //
// ReviewConfirm.vue?763eca80